import { mdiCheckCircle, mdiRadioboxBlank, mdiRadioboxMarked, mdiRefreshCircle } from '@lumapps/lumx/icons';
import { ColorPalette, ColorVariant } from '@lumapps/lumx/react';

export enum PROGRESS_STATUSES {
    TODO = 'todo',
    IN_PROGRESS = 'in-progress',
    DONE = 'done',
    CONFIRMED = 'confirmed',
    FAILED = 'failed',
}

export const PROGRESS_CONFIG = {
    icon: {
        [PROGRESS_STATUSES.TODO]: mdiRadioboxBlank,
        [PROGRESS_STATUSES.IN_PROGRESS]: mdiRadioboxBlank,
        [PROGRESS_STATUSES.DONE]: mdiRadioboxMarked,
        [PROGRESS_STATUSES.CONFIRMED]: mdiCheckCircle,
        [PROGRESS_STATUSES.FAILED]: mdiRefreshCircle,
    },
    color: {
        [PROGRESS_STATUSES.TODO]: ColorPalette.dark,
        [PROGRESS_STATUSES.IN_PROGRESS]: ColorPalette.primary,
        [PROGRESS_STATUSES.DONE]: ColorPalette.primary,
        [PROGRESS_STATUSES.CONFIRMED]: ColorPalette.primary,
        [PROGRESS_STATUSES.FAILED]: ColorPalette.yellow,
    },
    colorVariant: {
        [PROGRESS_STATUSES.TODO]: ColorVariant.L5,
        [PROGRESS_STATUSES.IN_PROGRESS]: ColorVariant.N,
        [PROGRESS_STATUSES.DONE]: ColorVariant.N,
        [PROGRESS_STATUSES.CONFIRMED]: ColorVariant.N,
        [PROGRESS_STATUSES.FAILED]: ColorVariant.N,
    },
};

export enum STEP_STATUS {
    ACTIVE = 'active',
    DEACTIVE = 'deactive',
    COMPLETE = 'completed',
    FAILED = 'failed',
}

export enum STEP_COUNTER_POSITION {
    START = 'start',
    END = 'end',
}

export const STEP_PROGRESSION_BAR_CONFIG = {
    color: {
        [STEP_STATUS.ACTIVE]: ColorPalette.primary,
        [STEP_STATUS.DEACTIVE]: ColorPalette.dark,
        [STEP_STATUS.COMPLETE]: ColorPalette.primary,
        [STEP_STATUS.FAILED]: ColorPalette.red,
    },
    colorVariant: {
        [STEP_STATUS.ACTIVE]: ColorVariant.N,
        [STEP_STATUS.DEACTIVE]: ColorVariant.L5,
        [STEP_STATUS.COMPLETE]: ColorVariant.N,
        [STEP_STATUS.FAILED]: ColorVariant.N,
    },
};
